import React, { useState } from "react";
import styles from "../../styles/components/banner.module.scss";
import endpoints from "../../utility/endpoints";
import BotStats from "../botStats/BotStats";
import BotDetailedStats from "../botStats/BotDetailedStats";
import { IoMdClose } from "react-icons/io";
import BotDashboard from "../botStats/BotDashboard";

export default function index(props) {
  //console.log(props,"boturl")
  const image = props.data.field_background_image[0];
  const bgimage = props.data.field_background_image_mobile[0];

  const [openDetailedStat, setOpenDetailedStat] = useState(false); 

  return (
   <>
    <div className={`${styles.bannerWrapper} container-fluid`}>
      <div className={`${styles.row} row`}>
        <div className="col-12">
          <div className={styles.imaging}>
            <img
              className={styles.image}
              src={endpoints.drupalIp + image.file_url}
              alt={image.image_alt}
            />
            <img
              className={styles.imageMobile}
              src={endpoints.drupalIp + bgimage.file_url}
              alt={bgimage.image_alt}
            />
          </div>
          <div className={`${styles.container} container py-4 relative`}>
            <p className={styles.bannerHead}>{props.data.field_hedaing}</p>
            <div
              className={styles.bannerText}
              dangerouslySetInnerHTML={{ __html: props.data.field_details }}
            ></div>
            <div className="absolute z-10 right-5 top-0 h-full w-[47%] hidden lg:flex  justify-center items-center">
              <BotStats />
            </div>
            <button
                onClick={() => setOpenDetailedStat(!openDetailedStat)}
                className="absolute flex items-center right-5 top-3 px-[4px] py-[2px] z-10 text-xs bg-[rgba(255,255,255,0.8)] "
              >
                Detailed Stats{" "}
                {openDetailedStat && <IoMdClose className="w-4 h-4" />}
              </button>
              {openDetailedStat && (
                <BotDashboard openDetailedStat={openDetailedStat} />
              )}
          </div>
        </div>
      </div>
    </div>
    <div className="lg:hidden flex bg-[#00d7c5] justify-center items-center py-3 w-full">
        <div className="w-2/3">
          <BotStats />
        </div>
      </div>
  </>
  );
}

